import React from 'react'
import style from '../card.module.css'

function Test1() {
  return (
    <div className={style.prepration_card}>
        <h3>Airforce X and Y</h3>
        <button>Free</button> 
        <div>
        <p>Test 1 . Mar 23, 5:32 PM</p>      
        </div>
    </div>
  )
}

export default Test1